import React from 'react';
const objections = [{
  q: '"No tengo tiempo para cocinar"',
  a: 'Las recetas tienen 3-5 ingredientes y se preparan en 15 minutos o menos. Muchas mujeres con hijos y trabajo full-time lo lograron.'
}, {
  q: '"Ya probé de todo y nada me funcionó"',
  a: 'Este método no es una dieta más. Trabaja desde la raíz: desinflamar y reiniciar tu metabolismo. Por eso funciona cuando todo lo demás falló.'
}, {
  q: '"Es muy caro para mí"',
  a: 'Una sola consulta con nutricionista cuesta más que todo este programa. Y acá tenés el plan completo de 21 días, recetas y acompañamiento de por vida.'
}, {
  q: '"Tengo problemas hormonales / tiroides"',
  a: 'Justamente fue diseñado para metabolismos complicados. Muchas mujeres con hipotiroidismo y en menopausia tuvieron resultados increíbles.'
}, {
  q: '"¿Y si no me funciona?"',
  a: 'Tenés 7 días de garantía total. Si no ves resultados o no te gusta, te devolvemos cada peso. Cero riesgo.'
}];
export function ObjectionBuster() {
  return <section className="py-20 bg-bg-warm" data-id="element-147">
      <div className="container mx-auto px-4 max-w-4xl fade-in-section" data-id="element-148">
        <div className="text-center mb-12" data-id="element-149">
          <h2 className="text-3xl md:text-4xl font-bold text-text-dark mb-4" data-id="element-150">
            Tal vez estás pensando...
          </h2>
          <p className="text-lg text-text-medium" data-id="element-151">
            Estas son las dudas más comunes (y por qué no deberían frenarte)
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-152">
          {objections.map((obj, index) => <div key={index} className={`bg-white p-6 rounded-2xl shadow-soft border border-beige-dark ${index === objections.length - 1 ? 'md:col-span-2 md:max-w-xl md:mx-auto w-full' : ''}`} data-id="element-153">
              <h3 className="text-xl font-bold text-coral italic mb-3 font-heading" data-id="element-154">
                {obj.q}
              </h3>
              <p className="text-text-medium leading-relaxed" data-id="element-155">{obj.a}</p>
            </div>)}
        </div>
      </div>
    </section>;
}